import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleComponent } from '@pages/utils/google.component';
import { GoogleTagManagerEventEnum } from 'src/app/enums/GoogleTagManagerEvent.enum';
import { TagManagerDirective } from '../../directives/tag-manager.directive';

@Component({
    selector: 'app-alert-sucesso',
    templateUrl: './alert-sucesso.component.html',
    styleUrls: ['./alert-sucesso.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TagManagerDirective]
})
export class AlertSucessoComponent extends GoogleComponent implements OnChanges {

  public idImportacao: any = localStorage.idImportacao;
  @Input() alertSucesso: boolean = false;
  @Input() alertSucessoMensagem: string;
  @Input() alertSucessoSubtitulo: string;
  @Input() sourceScreen: string = '';

  @Output() alertSucessoAvancou = new EventEmitter();
  @Output() alertSucessoFechou = new EventEmitter();

  constructor(public rota: Router) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.alertSucesso?.currentValue && this.sourceScreen !== '') {
      const model = this.buildTagFromSourceScreen(GoogleTagManagerEventEnum.screenView, null, null, this.sourceScreen);
      this.tagManagerService.pushTag(model);
    }
  }

  addTagManagerInteraction(elementType: string, elementContent: string) {
    return this.buildTagFromSourceScreen(GoogleTagManagerEventEnum.interaction, elementType, elementContent, this.sourceScreen);
  }

  async fecharAlertSucesso() {
    this.alertSucessoFechou.emit('Fechou');
    if (this.alertSucessoSubtitulo === 'Importação realizada com sucesso!') {
      localStorage.removeItem(localStorage.getItem('idEmpresaLogada') + '.ImportadorDadosComponent.avisoInconsistencia.value');
      this.rota.navigate(['importador-dados']);
    }
  }
}
